module.exports = __webpack_public_path__ + "static/media/fotografia-8.a80b5f56.png";